import React from "react";
import styled from "styled-components";
import LoggingLink from "../../elements/LoggingLink";

const StyledLoggingLink = styled(LoggingLink)`
  color: inherit;
  text-decoration: none;
  display: block;
`;

const CompanyWithinPortfolioLink = ({ourProgrammeContext, portfolioCompanyName, contributorCompanyId, contributorCompanyName, children}) => {

    const loggingPayload = () => {
        const {portfolioId, portfolioName} = ourProgrammeContext.context();
        return { type: `COMPANY_ROW_CLICKED`,
            portfolioId: portfolioId,
            portfolioName: portfolioName,
            portfolioCompanyName: portfolioCompanyName,
            companyId: contributorCompanyId,
            companyName: contributorCompanyName };
    };

    return contributorCompanyName === 'REDACTED'
            ? children
            : <StyledLoggingLink to={ourProgrammeContext.companyWithinPortfolioOverviewPath(contributorCompanyId)}
                                 loggingPayload={loggingPayload()}
                                 className="t-company-within-portfolio-link" >
                  {children}
              </StyledLoggingLink>;
};

export default CompanyWithinPortfolioLink;